module.exports = __webpack_public_path__ + "img/keyboard-down.440663fa.svg";